import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  DialogService,
  Destroy,
  Guard,
  NullEntity,
  ViewMode,
  Key,
  BreadCrumbService,
  tr,
  AuthService,
} from '@kpd/framework-ngx';
import { UserFacade } from 'app/shared/services/facades/user.facade';
import { UsersNavigatorHelper } from 'app/users/users-navigator-helper';
import { UserManagementEntityUpdater } from 'app/shared/services/entity-updater';
import { User } from 'app/shared/models/user';
import { LicenseService } from 'app/shared/services/license.service';
import { Permissions } from 'app/shared/services/permissions';
import { UserDetailsGeneralComponent } from './user-details-general.component';

@Component({
  selector: 'app-users-details',
  templateUrl: './user-details.component.html',
})
export class UserDetailsComponent implements OnInit, OnDestroy {
  Permissions: typeof Permissions = Permissions;
  currentItem: User | NullEntity = new User();
  entityUpdater: UserManagementEntityUpdater;
  viewMode = ViewMode.Consult;
  showNavigation = true;
  tabLabels = {
    licenseCount: 0,
    roleCount: 0,
  };

  @ViewChild(UserDetailsGeneralComponent, { static: false })
  userDetailsGeneral: UserDetailsGeneralComponent;

  @Destroy()
  destroy$: any;
  demonstrativePronoun = tr('ThisDeze');

  constructor(
    dialogService: DialogService,
    guard: Guard,
    public navigatorHelper: UsersNavigatorHelper,
    public userFacade: UserFacade,
    private route: ActivatedRoute,
    private licenseService: LicenseService,
    private authService: AuthService,
    breadCrumbService: BreadCrumbService,
  ) {
    this.entityUpdater = new UserManagementEntityUpdater(
      dialogService,
      this.navigatorHelper,
      this.userFacade,
      guard,
      breadCrumbService,
      'users',
    );
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.viewMode = params['mode'];
    });
    this.route.data.subscribe((data) => {
      if (data.currentUser) {
        this.showNavigation = false;
        this.userFacade.clearSelection();
        this.userFacade.getCurrent(new Key<string>(data.currentUser.upn)).subscribe((user) => {
          this.onItemChanged(user);
        });
      }
    });
  }

  onClose(): void {
    this.navigatorHelper.back();
  }

  onItemChanged(event: User | NullEntity): void {
    if (event instanceof NullEntity) {
      this.currentItem = event;
      return;
    }
    const activeTenantId = this.authService.getTenant().key.id;
    if (event instanceof User && event.upn) {
      this.licenseService.getLicensesForUser(event.upn).subscribe((licenses) => {
        this.tabLabels.licenseCount = licenses.filter((l) => !l.isExpired).length;
        this.tabLabels.roleCount = event.getRolesCount(activeTenantId);
      });
    }
    this.currentItem = event;
  }

  changeTabLabel(tab: string, amount: number): void {
    this.tabLabels[tab] = amount;
  }

  onSwitchMode(mode: string): void {
    this.navigatorHelper.navigateByQueryString({ tab: this.route.snapshot.queryParams['tab'], mode: mode });
  }

  onTabChanged(): void {
    if (this.userDetailsGeneral && this.userDetailsGeneral.form && this.userDetailsGeneral.form.dirty === false) {
      this.userFacade.reloadUser(this.currentItem as User).subscribe((user: User) => {
        this.currentItem = user;
      });
    }
  }

  ngOnDestroy(): void {
    this.entityUpdater.destroy();
  }
}
